/*! @azure/msal-browser v3.18.0 2024-07-01 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.18.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
